module.exports = __webpack_public_path__ + "img/video-evaluation.96dcf8d2.svg";